import styled from 'styled-components';

export const ContainerPage = styled.div`
  position: relative;
  z-index: 9;
  background-color: #ffffff;
  padding: 50px 0px 50px;
`;
